/* tslint:disable */
/* eslint-disable */
/**
 * Staking Reporting API
 * ### Protocols The following protocols are currently supported: * Cardano * Cosmos * Ethereum * NEAR * Polkadot * Polygon  * Solana
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@blockdaemon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common.js';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base.js';
/**
 * SolanaStakingReportingApi - axios parameter creator
 */
export const SolanaStakingReportingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * The status of reward processing, if optimal then all rewards data up to the indicated metadata fields are available the processing status is degraded if any of the following are true:    * `chainEpoch` - `lastProcessedInflationEpoch` > 1   * `chainEpoch` - `lastProcessedStatusesEpoch` > 1   * if the `lastProcessedSlot` is over 20 minutes behind the chainSlot - note we run 10 minutes behind by design to alleviate any reorgs so this is a 10 minuate buffer on top of that   * `chainEpoch` - `lastProcessedMevEpoch` > 1   * if the `lastProcessedMevTxTimestamp` is older than 3.2 days, this is mainly as a check to see if the jito mev bot has paid out expectedly or not, not that our system is degraded    **Please note** that mev rewards are allocated to the epoch they are paid out in *not* the epoch they are earned in.
         * @summary Get the Protocol Rewards Processing Health
         * @param {string} network The network to look up against
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealth1: async (network, options = {}) => {
            // verify required parameter 'network' is not null or undefined
            assertParamExists('getHealth1', 'network', network);
            const localVarPath = `/v2/solana/{network}/health`
                .replace(`{${"network"}}`, encodeURIComponent(String(network)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns 0 or more reward objects in a streaming fashion using `ndjson`.
         * @summary Get a Stream of Rewards
         * @param {string} network The network to look up against.
         * @param {Type} type
         * @param {RewardRequest1} rewardRequest1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewards1: async (network, type, rewardRequest1, options = {}) => {
            // verify required parameter 'network' is not null or undefined
            assertParamExists('getRewards1', 'network', network);
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getRewards1', 'type', type);
            // verify required parameter 'rewardRequest1' is not null or undefined
            assertParamExists('getRewards1', 'rewardRequest1', rewardRequest1);
            const localVarPath = `/v2/solana/{network}/{type}/rewards`
                .replace(`{${"network"}}`, encodeURIComponent(String(network)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/x-ndjson,application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(rewardRequest1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns 0 or more reward objects in a streaming fashion using `ndjson`. Must specify either a start and end time or an epoch
         * @summary Get a Stream of Rewards for a Single Address
         * @param {string} network The network to look up against.
         * @param {Type} type
         * @param {string} address The address to look up rewards for.
         * @param {TimePeriod2} period The type of aggregation to apply.
         * @param {number} [startTime] Epoch-based start time for reward queries. You can not specify both an epoch and start/end times.
         * @param {number} [endTime] Epoch-based end time for reward queries. You can not specify both an epoch and start/end times
         * @param {number} [epoch] The epoch to look up rewards for, you can not specify both an epoch and start/end times
         * @param {Denomination1} [denomination] the denomination to return the rewards in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardsSingle1: async (network, type, address, period, startTime, endTime, epoch, denomination, options = {}) => {
            // verify required parameter 'network' is not null or undefined
            assertParamExists('getRewardsSingle1', 'network', network);
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getRewardsSingle1', 'type', type);
            // verify required parameter 'address' is not null or undefined
            assertParamExists('getRewardsSingle1', 'address', address);
            // verify required parameter 'period' is not null or undefined
            assertParamExists('getRewardsSingle1', 'period', period);
            const localVarPath = `/v2/solana/{network}/{type}/rewards/{address}`
                .replace(`{${"network"}}`, encodeURIComponent(String(network)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }
            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }
            if (epoch !== undefined) {
                localVarQueryParameter['epoch'] = epoch;
            }
            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }
            if (denomination !== undefined) {
                localVarQueryParameter['denomination'] = denomination;
            }
            localVarHeaderParameter['Accept'] = 'application/x-ndjson,application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns stats for an address including 30 and 90 days of yield and rewards data based  on utc days  If an address is not currently monitored a 404 is returned, on the first query for an address data is async calculated and then updated daily
         * @summary Get Stats for an address
         * @param {string} network The blockchain network to query (e.g., mainnet).
         * @param {Type} type
         * @param {string} address The validator address to retrieve stats data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatsSolana: async (network, type, address, options = {}) => {
            // verify required parameter 'network' is not null or undefined
            assertParamExists('getStatsSolana', 'network', network);
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getStatsSolana', 'type', type);
            // verify required parameter 'address' is not null or undefined
            assertParamExists('getStatsSolana', 'address', address);
            const localVarPath = `/v2/solana/{network}/{type}/stats/{address}`
                .replace(`{${"network"}}`, encodeURIComponent(String(network)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a status object for an address.
         * @summary Get Status for an Address
         * @param {string} network The network to look up against
         * @param {Type} type
         * @param {string} address The address to look up rewards for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus1: async (network, type, address, options = {}) => {
            // verify required parameter 'network' is not null or undefined
            assertParamExists('getStatus1', 'network', network);
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getStatus1', 'type', type);
            // verify required parameter 'address' is not null or undefined
            assertParamExists('getStatus1', 'address', address);
            const localVarPath = `/v2/solana/{network}/{type}/status/{address}`
                .replace(`{${"network"}}`, encodeURIComponent(String(network)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns 0 or more status objects in a streaming fashion using `ndjson`.
         * @summary Get a Stream of Statuses
         * @param {string} network The network to look up against.
         * @param {Type} type
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatuses1: async (network, type, requestBody, options = {}) => {
            // verify required parameter 'network' is not null or undefined
            assertParamExists('getStatuses1', 'network', network);
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getStatuses1', 'type', type);
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getStatuses1', 'requestBody', requestBody);
            const localVarPath = `/v2/solana/{network}/{type}/status`
                .replace(`{${"network"}}`, encodeURIComponent(String(network)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/x-ndjson,application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns yield data for the specified validator address within a given type.   For more details on yield metrics and how they are calculated, see the [Yield Metrics overview](https://docs.blockdaemon.com/reference/stakingreporting-api-overview).  ⚠️ **Note:** This endpoint does not support validators with a 100% commission rate and will not return yield data for them.
         * @summary Get a Yield for a Validator Address
         * @param {string} network The blockchain network to query (e.g., mainnet).
         * @param {TypeYieldSolana} type The type of yield data to retrieve: - &#x60;validator&#x60;: includes the validator’s own rewards. - &#x60;delegator&#x60;: includes rewards distributed to delegators of that validator.
         * @param {string} address The validator address to query yield data for.
         * @param {number} startTime Epoch-based start time for reward queries.
         * @param {number} endTime Epoch-based end time for reward queries.
         * @param {Denomination1} [denomination] The unit to return the yield in (e.g., &#x60;lamports&#x60;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYieldSolana: async (network, type, address, startTime, endTime, denomination, options = {}) => {
            // verify required parameter 'network' is not null or undefined
            assertParamExists('getYieldSolana', 'network', network);
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getYieldSolana', 'type', type);
            // verify required parameter 'address' is not null or undefined
            assertParamExists('getYieldSolana', 'address', address);
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getYieldSolana', 'startTime', startTime);
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getYieldSolana', 'endTime', endTime);
            const localVarPath = `/v2/solana/{network}/{type}/yield/{address}`
                .replace(`{${"network"}}`, encodeURIComponent(String(network)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }
            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }
            if (denomination !== undefined) {
                localVarQueryParameter['denomination'] = denomination;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a **network-wide** stream of yield summaries for the specified type and time range. Results are streamed in [NDJSON](https://ndjson.org/) format.  For more details on yield metrics and how they are calculated, see the [Yield Metrics overview](https://docs.blockdaemon.com/reference/stakingreporting-api-overview).
         * @summary Get a Stream of Yield Summaries
         * @param {string} network The blockchain network to query (e.g., mainnet).
         * @param {TypeYieldSolana} type The type of yield data to retrieve: - &#x60;validator&#x60;: includes the validator’s own rewards. - &#x60;delegator&#x60;: includes rewards distributed to delegators of that validator.  Call both endpoints and aggregate the results to get a complete network-wide view.
         * @param {number} startTime Epoch-based start time for reward queries.
         * @param {number} endTime Epoch-based end time for reward queries.
         * @param {Denomination1} [denomination] The unit to return the yield in (e.g., &#x60;lamports&#x60;).
         * @param {boolean} [raw] Gives the yield values raw per-epoch. Set to &#x60;true&#x60; to get per-epoch raw values.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYieldsSolana: async (network, type, startTime, endTime, denomination, raw, options = {}) => {
            // verify required parameter 'network' is not null or undefined
            assertParamExists('getYieldsSolana', 'network', network);
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getYieldsSolana', 'type', type);
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getYieldsSolana', 'startTime', startTime);
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getYieldsSolana', 'endTime', endTime);
            const localVarPath = `/v2/solana/{network}/{type}/yield`
                .replace(`{${"network"}}`, encodeURIComponent(String(network)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }
            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }
            if (denomination !== undefined) {
                localVarQueryParameter['denomination'] = denomination;
            }
            if (raw !== undefined) {
                localVarQueryParameter['raw'] = raw;
            }
            localVarHeaderParameter['Accept'] = 'application/x-ndjson,application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Preemptively add an address to the stats tracking
         * @param {string} network The blockchain network to query (e.g., mainnet).
         * @param {Type} type
         * @param {string} address The validator address to retrieve stats data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putStatsSolana: async (network, type, address, options = {}) => {
            // verify required parameter 'network' is not null or undefined
            assertParamExists('putStatsSolana', 'network', network);
            // verify required parameter 'type' is not null or undefined
            assertParamExists('putStatsSolana', 'type', type);
            // verify required parameter 'address' is not null or undefined
            assertParamExists('putStatsSolana', 'address', address);
            const localVarPath = `/v2/solana/{network}/{type}/stats/{address}`
                .replace(`{${"network"}}`, encodeURIComponent(String(network)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKeyAuthHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SolanaStakingReportingApi - functional programming interface
 */
export const SolanaStakingReportingApiFp = function (configuration) {
    const localVarAxiosParamCreator = SolanaStakingReportingApiAxiosParamCreator(configuration);
    return {
        /**
         * The status of reward processing, if optimal then all rewards data up to the indicated metadata fields are available the processing status is degraded if any of the following are true:    * `chainEpoch` - `lastProcessedInflationEpoch` > 1   * `chainEpoch` - `lastProcessedStatusesEpoch` > 1   * if the `lastProcessedSlot` is over 20 minutes behind the chainSlot - note we run 10 minutes behind by design to alleviate any reorgs so this is a 10 minuate buffer on top of that   * `chainEpoch` - `lastProcessedMevEpoch` > 1   * if the `lastProcessedMevTxTimestamp` is older than 3.2 days, this is mainly as a check to see if the jito mev bot has paid out expectedly or not, not that our system is degraded    **Please note** that mev rewards are allocated to the epoch they are paid out in *not* the epoch they are earned in.
         * @summary Get the Protocol Rewards Processing Health
         * @param {string} network The network to look up against
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHealth1(network, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHealth1(network, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SolanaStakingReportingApi.getHealth1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns 0 or more reward objects in a streaming fashion using `ndjson`.
         * @summary Get a Stream of Rewards
         * @param {string} network The network to look up against.
         * @param {Type} type
         * @param {RewardRequest1} rewardRequest1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRewards1(network, type, rewardRequest1, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRewards1(network, type, rewardRequest1, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SolanaStakingReportingApi.getRewards1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns 0 or more reward objects in a streaming fashion using `ndjson`. Must specify either a start and end time or an epoch
         * @summary Get a Stream of Rewards for a Single Address
         * @param {string} network The network to look up against.
         * @param {Type} type
         * @param {string} address The address to look up rewards for.
         * @param {TimePeriod2} period The type of aggregation to apply.
         * @param {number} [startTime] Epoch-based start time for reward queries. You can not specify both an epoch and start/end times.
         * @param {number} [endTime] Epoch-based end time for reward queries. You can not specify both an epoch and start/end times
         * @param {number} [epoch] The epoch to look up rewards for, you can not specify both an epoch and start/end times
         * @param {Denomination1} [denomination] the denomination to return the rewards in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRewardsSingle1(network, type, address, period, startTime, endTime, epoch, denomination, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRewardsSingle1(network, type, address, period, startTime, endTime, epoch, denomination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SolanaStakingReportingApi.getRewardsSingle1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns stats for an address including 30 and 90 days of yield and rewards data based  on utc days  If an address is not currently monitored a 404 is returned, on the first query for an address data is async calculated and then updated daily
         * @summary Get Stats for an address
         * @param {string} network The blockchain network to query (e.g., mainnet).
         * @param {Type} type
         * @param {string} address The validator address to retrieve stats data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatsSolana(network, type, address, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatsSolana(network, type, address, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SolanaStakingReportingApi.getStatsSolana']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a status object for an address.
         * @summary Get Status for an Address
         * @param {string} network The network to look up against
         * @param {Type} type
         * @param {string} address The address to look up rewards for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatus1(network, type, address, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatus1(network, type, address, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SolanaStakingReportingApi.getStatus1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns 0 or more status objects in a streaming fashion using `ndjson`.
         * @summary Get a Stream of Statuses
         * @param {string} network The network to look up against.
         * @param {Type} type
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatuses1(network, type, requestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatuses1(network, type, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SolanaStakingReportingApi.getStatuses1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns yield data for the specified validator address within a given type.   For more details on yield metrics and how they are calculated, see the [Yield Metrics overview](https://docs.blockdaemon.com/reference/stakingreporting-api-overview).  ⚠️ **Note:** This endpoint does not support validators with a 100% commission rate and will not return yield data for them.
         * @summary Get a Yield for a Validator Address
         * @param {string} network The blockchain network to query (e.g., mainnet).
         * @param {TypeYieldSolana} type The type of yield data to retrieve: - &#x60;validator&#x60;: includes the validator’s own rewards. - &#x60;delegator&#x60;: includes rewards distributed to delegators of that validator.
         * @param {string} address The validator address to query yield data for.
         * @param {number} startTime Epoch-based start time for reward queries.
         * @param {number} endTime Epoch-based end time for reward queries.
         * @param {Denomination1} [denomination] The unit to return the yield in (e.g., &#x60;lamports&#x60;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getYieldSolana(network, type, address, startTime, endTime, denomination, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getYieldSolana(network, type, address, startTime, endTime, denomination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SolanaStakingReportingApi.getYieldSolana']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a **network-wide** stream of yield summaries for the specified type and time range. Results are streamed in [NDJSON](https://ndjson.org/) format.  For more details on yield metrics and how they are calculated, see the [Yield Metrics overview](https://docs.blockdaemon.com/reference/stakingreporting-api-overview).
         * @summary Get a Stream of Yield Summaries
         * @param {string} network The blockchain network to query (e.g., mainnet).
         * @param {TypeYieldSolana} type The type of yield data to retrieve: - &#x60;validator&#x60;: includes the validator’s own rewards. - &#x60;delegator&#x60;: includes rewards distributed to delegators of that validator.  Call both endpoints and aggregate the results to get a complete network-wide view.
         * @param {number} startTime Epoch-based start time for reward queries.
         * @param {number} endTime Epoch-based end time for reward queries.
         * @param {Denomination1} [denomination] The unit to return the yield in (e.g., &#x60;lamports&#x60;).
         * @param {boolean} [raw] Gives the yield values raw per-epoch. Set to &#x60;true&#x60; to get per-epoch raw values.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getYieldsSolana(network, type, startTime, endTime, denomination, raw, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getYieldsSolana(network, type, startTime, endTime, denomination, raw, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SolanaStakingReportingApi.getYieldsSolana']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Preemptively add an address to the stats tracking
         * @param {string} network The blockchain network to query (e.g., mainnet).
         * @param {Type} type
         * @param {string} address The validator address to retrieve stats data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putStatsSolana(network, type, address, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putStatsSolana(network, type, address, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SolanaStakingReportingApi.putStatsSolana']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SolanaStakingReportingApi - factory interface
 */
export const SolanaStakingReportingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SolanaStakingReportingApiFp(configuration);
    return {
        /**
         * The status of reward processing, if optimal then all rewards data up to the indicated metadata fields are available the processing status is degraded if any of the following are true:    * `chainEpoch` - `lastProcessedInflationEpoch` > 1   * `chainEpoch` - `lastProcessedStatusesEpoch` > 1   * if the `lastProcessedSlot` is over 20 minutes behind the chainSlot - note we run 10 minutes behind by design to alleviate any reorgs so this is a 10 minuate buffer on top of that   * `chainEpoch` - `lastProcessedMevEpoch` > 1   * if the `lastProcessedMevTxTimestamp` is older than 3.2 days, this is mainly as a check to see if the jito mev bot has paid out expectedly or not, not that our system is degraded    **Please note** that mev rewards are allocated to the epoch they are paid out in *not* the epoch they are earned in.
         * @summary Get the Protocol Rewards Processing Health
         * @param {string} network The network to look up against
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealth1(network, options) {
            return localVarFp.getHealth1(network, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns 0 or more reward objects in a streaming fashion using `ndjson`.
         * @summary Get a Stream of Rewards
         * @param {string} network The network to look up against.
         * @param {Type} type
         * @param {RewardRequest1} rewardRequest1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewards1(network, type, rewardRequest1, options) {
            return localVarFp.getRewards1(network, type, rewardRequest1, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns 0 or more reward objects in a streaming fashion using `ndjson`. Must specify either a start and end time or an epoch
         * @summary Get a Stream of Rewards for a Single Address
         * @param {string} network The network to look up against.
         * @param {Type} type
         * @param {string} address The address to look up rewards for.
         * @param {TimePeriod2} period The type of aggregation to apply.
         * @param {number} [startTime] Epoch-based start time for reward queries. You can not specify both an epoch and start/end times.
         * @param {number} [endTime] Epoch-based end time for reward queries. You can not specify both an epoch and start/end times
         * @param {number} [epoch] The epoch to look up rewards for, you can not specify both an epoch and start/end times
         * @param {Denomination1} [denomination] the denomination to return the rewards in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardsSingle1(network, type, address, period, startTime, endTime, epoch, denomination, options) {
            return localVarFp.getRewardsSingle1(network, type, address, period, startTime, endTime, epoch, denomination, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns stats for an address including 30 and 90 days of yield and rewards data based  on utc days  If an address is not currently monitored a 404 is returned, on the first query for an address data is async calculated and then updated daily
         * @summary Get Stats for an address
         * @param {string} network The blockchain network to query (e.g., mainnet).
         * @param {Type} type
         * @param {string} address The validator address to retrieve stats data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatsSolana(network, type, address, options) {
            return localVarFp.getStatsSolana(network, type, address, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a status object for an address.
         * @summary Get Status for an Address
         * @param {string} network The network to look up against
         * @param {Type} type
         * @param {string} address The address to look up rewards for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus1(network, type, address, options) {
            return localVarFp.getStatus1(network, type, address, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns 0 or more status objects in a streaming fashion using `ndjson`.
         * @summary Get a Stream of Statuses
         * @param {string} network The network to look up against.
         * @param {Type} type
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatuses1(network, type, requestBody, options) {
            return localVarFp.getStatuses1(network, type, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns yield data for the specified validator address within a given type.   For more details on yield metrics and how they are calculated, see the [Yield Metrics overview](https://docs.blockdaemon.com/reference/stakingreporting-api-overview).  ⚠️ **Note:** This endpoint does not support validators with a 100% commission rate and will not return yield data for them.
         * @summary Get a Yield for a Validator Address
         * @param {string} network The blockchain network to query (e.g., mainnet).
         * @param {TypeYieldSolana} type The type of yield data to retrieve: - &#x60;validator&#x60;: includes the validator’s own rewards. - &#x60;delegator&#x60;: includes rewards distributed to delegators of that validator.
         * @param {string} address The validator address to query yield data for.
         * @param {number} startTime Epoch-based start time for reward queries.
         * @param {number} endTime Epoch-based end time for reward queries.
         * @param {Denomination1} [denomination] The unit to return the yield in (e.g., &#x60;lamports&#x60;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYieldSolana(network, type, address, startTime, endTime, denomination, options) {
            return localVarFp.getYieldSolana(network, type, address, startTime, endTime, denomination, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a **network-wide** stream of yield summaries for the specified type and time range. Results are streamed in [NDJSON](https://ndjson.org/) format.  For more details on yield metrics and how they are calculated, see the [Yield Metrics overview](https://docs.blockdaemon.com/reference/stakingreporting-api-overview).
         * @summary Get a Stream of Yield Summaries
         * @param {string} network The blockchain network to query (e.g., mainnet).
         * @param {TypeYieldSolana} type The type of yield data to retrieve: - &#x60;validator&#x60;: includes the validator’s own rewards. - &#x60;delegator&#x60;: includes rewards distributed to delegators of that validator.  Call both endpoints and aggregate the results to get a complete network-wide view.
         * @param {number} startTime Epoch-based start time for reward queries.
         * @param {number} endTime Epoch-based end time for reward queries.
         * @param {Denomination1} [denomination] The unit to return the yield in (e.g., &#x60;lamports&#x60;).
         * @param {boolean} [raw] Gives the yield values raw per-epoch. Set to &#x60;true&#x60; to get per-epoch raw values.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYieldsSolana(network, type, startTime, endTime, denomination, raw, options) {
            return localVarFp.getYieldsSolana(network, type, startTime, endTime, denomination, raw, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Preemptively add an address to the stats tracking
         * @param {string} network The blockchain network to query (e.g., mainnet).
         * @param {Type} type
         * @param {string} address The validator address to retrieve stats data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putStatsSolana(network, type, address, options) {
            return localVarFp.putStatsSolana(network, type, address, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SolanaStakingReportingApi - object-oriented interface
 */
export class SolanaStakingReportingApi extends BaseAPI {
    /**
     * The status of reward processing, if optimal then all rewards data up to the indicated metadata fields are available the processing status is degraded if any of the following are true:    * `chainEpoch` - `lastProcessedInflationEpoch` > 1   * `chainEpoch` - `lastProcessedStatusesEpoch` > 1   * if the `lastProcessedSlot` is over 20 minutes behind the chainSlot - note we run 10 minutes behind by design to alleviate any reorgs so this is a 10 minuate buffer on top of that   * `chainEpoch` - `lastProcessedMevEpoch` > 1   * if the `lastProcessedMevTxTimestamp` is older than 3.2 days, this is mainly as a check to see if the jito mev bot has paid out expectedly or not, not that our system is degraded    **Please note** that mev rewards are allocated to the epoch they are paid out in *not* the epoch they are earned in.
     * @summary Get the Protocol Rewards Processing Health
     * @param {string} network The network to look up against
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHealth1(network, options) {
        return SolanaStakingReportingApiFp(this.configuration).getHealth1(network, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns 0 or more reward objects in a streaming fashion using `ndjson`.
     * @summary Get a Stream of Rewards
     * @param {string} network The network to look up against.
     * @param {Type} type
     * @param {RewardRequest1} rewardRequest1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRewards1(network, type, rewardRequest1, options) {
        return SolanaStakingReportingApiFp(this.configuration).getRewards1(network, type, rewardRequest1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns 0 or more reward objects in a streaming fashion using `ndjson`. Must specify either a start and end time or an epoch
     * @summary Get a Stream of Rewards for a Single Address
     * @param {string} network The network to look up against.
     * @param {Type} type
     * @param {string} address The address to look up rewards for.
     * @param {TimePeriod2} period The type of aggregation to apply.
     * @param {number} [startTime] Epoch-based start time for reward queries. You can not specify both an epoch and start/end times.
     * @param {number} [endTime] Epoch-based end time for reward queries. You can not specify both an epoch and start/end times
     * @param {number} [epoch] The epoch to look up rewards for, you can not specify both an epoch and start/end times
     * @param {Denomination1} [denomination] the denomination to return the rewards in
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRewardsSingle1(network, type, address, period, startTime, endTime, epoch, denomination, options) {
        return SolanaStakingReportingApiFp(this.configuration).getRewardsSingle1(network, type, address, period, startTime, endTime, epoch, denomination, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns stats for an address including 30 and 90 days of yield and rewards data based  on utc days  If an address is not currently monitored a 404 is returned, on the first query for an address data is async calculated and then updated daily
     * @summary Get Stats for an address
     * @param {string} network The blockchain network to query (e.g., mainnet).
     * @param {Type} type
     * @param {string} address The validator address to retrieve stats data for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStatsSolana(network, type, address, options) {
        return SolanaStakingReportingApiFp(this.configuration).getStatsSolana(network, type, address, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a status object for an address.
     * @summary Get Status for an Address
     * @param {string} network The network to look up against
     * @param {Type} type
     * @param {string} address The address to look up rewards for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStatus1(network, type, address, options) {
        return SolanaStakingReportingApiFp(this.configuration).getStatus1(network, type, address, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns 0 or more status objects in a streaming fashion using `ndjson`.
     * @summary Get a Stream of Statuses
     * @param {string} network The network to look up against.
     * @param {Type} type
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStatuses1(network, type, requestBody, options) {
        return SolanaStakingReportingApiFp(this.configuration).getStatuses1(network, type, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns yield data for the specified validator address within a given type.   For more details on yield metrics and how they are calculated, see the [Yield Metrics overview](https://docs.blockdaemon.com/reference/stakingreporting-api-overview).  ⚠️ **Note:** This endpoint does not support validators with a 100% commission rate and will not return yield data for them.
     * @summary Get a Yield for a Validator Address
     * @param {string} network The blockchain network to query (e.g., mainnet).
     * @param {TypeYieldSolana} type The type of yield data to retrieve: - &#x60;validator&#x60;: includes the validator’s own rewards. - &#x60;delegator&#x60;: includes rewards distributed to delegators of that validator.
     * @param {string} address The validator address to query yield data for.
     * @param {number} startTime Epoch-based start time for reward queries.
     * @param {number} endTime Epoch-based end time for reward queries.
     * @param {Denomination1} [denomination] The unit to return the yield in (e.g., &#x60;lamports&#x60;).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getYieldSolana(network, type, address, startTime, endTime, denomination, options) {
        return SolanaStakingReportingApiFp(this.configuration).getYieldSolana(network, type, address, startTime, endTime, denomination, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a **network-wide** stream of yield summaries for the specified type and time range. Results are streamed in [NDJSON](https://ndjson.org/) format.  For more details on yield metrics and how they are calculated, see the [Yield Metrics overview](https://docs.blockdaemon.com/reference/stakingreporting-api-overview).
     * @summary Get a Stream of Yield Summaries
     * @param {string} network The blockchain network to query (e.g., mainnet).
     * @param {TypeYieldSolana} type The type of yield data to retrieve: - &#x60;validator&#x60;: includes the validator’s own rewards. - &#x60;delegator&#x60;: includes rewards distributed to delegators of that validator.  Call both endpoints and aggregate the results to get a complete network-wide view.
     * @param {number} startTime Epoch-based start time for reward queries.
     * @param {number} endTime Epoch-based end time for reward queries.
     * @param {Denomination1} [denomination] The unit to return the yield in (e.g., &#x60;lamports&#x60;).
     * @param {boolean} [raw] Gives the yield values raw per-epoch. Set to &#x60;true&#x60; to get per-epoch raw values.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getYieldsSolana(network, type, startTime, endTime, denomination, raw, options) {
        return SolanaStakingReportingApiFp(this.configuration).getYieldsSolana(network, type, startTime, endTime, denomination, raw, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Preemptively add an address to the stats tracking
     * @param {string} network The blockchain network to query (e.g., mainnet).
     * @param {Type} type
     * @param {string} address The validator address to retrieve stats data for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putStatsSolana(network, type, address, options) {
        return SolanaStakingReportingApiFp(this.configuration).putStatsSolana(network, type, address, options).then((request) => request(this.axios, this.basePath));
    }
}
